import { Download, Share, X } from 'lucide-react';
import { useInstallPrompt } from '../hooks/useInstallPrompt';

export function InstallPrompt() {
  const { canInstall, dismiss, install, isIos, shouldShow } = useInstallPrompt();

  if (!shouldShow) return null;

  return (
    <aside
      className="fixed inset-x-3 z-[70] mx-auto max-w-md border border-line bg-white p-3 shadow-lg keyboard-hide"
      style={{ bottom: 'calc(72px + env(safe-area-inset-bottom))', borderRadius: 8 }}
      aria-label="Install DeadBird"
    >
      <div className="flex min-w-0 items-center gap-3">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-clay-50 text-clay-700">
          {isIos && !canInstall ? <Share size={21} aria-hidden="true" /> : <Download size={21} aria-hidden="true" />}
        </div>
        <div className="min-w-0 flex-1">
          <p className="font-data text-base font-bold leading-tight text-ink">Install DeadBird</p>
          <p className="mt-0.5 text-sm leading-snug text-body">
            {isIos && !canInstall ? 'Use Share, then Add to Home Screen.' : 'Open faster and keep field scoring ready.'}
          </p>
        </div>
        {canInstall && (
          <button
            type="button"
            onClick={() => void install()}
            className="min-h-11 shrink-0 rounded-md bg-clay-500 px-3 font-bold text-white hover:bg-clay-700"
          >
            Install
          </button>
        )}
        <button
          type="button"
          onClick={dismiss}
          className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md text-body hover:bg-cloud hover:text-ink"
          aria-label="Dismiss install prompt"
        >
          <X size={21} aria-hidden="true" />
        </button>
      </div>
    </aside>
  );
}
